import { defineMessages } from 'react-intl';
// Temporary code, waiting for translation tools in react

const units = defineMessages({
    cm: { id: 'listing.unit.cm', defaultMessage: 'cm', description: 'cm unit' },
    g: { id: 'listing.unit.g', defaultMessage: 'g', description: 'g unit' },
    kg: { id: 'listing.unit.kg', defaultMessage: 'kg', description: 'kg unit' },
    l: { id: 'listing.unit.l', defaultMessage: 'L', description: 'l unit' },
    m: { id: 'listing.unit.m', defaultMessage: 'm', description: 'm unit' },
    m2: { id: 'listing.unit.m2', defaultMessage: 'm2', description: 'm2 unit' },
    m3: { id: 'listing.unit.m3', defaultMessage: 'm3', description: 'm3 unit' },
    mg: { id: 'listing.unit.mg', defaultMessage: 'mg', description: 'mg unit' },
    ml: { id: 'listing.unit.ml', defaultMessage: 'ml', description: 'ml unit' },
    mm: { id: 'listing.unit.mm', defaultMessage: 'mm', description: 'mm unit' },
    piece: {
        id: 'listing.unit.piece',
        defaultMessage: 'piece',
        description: 'piece unit',
    },
});

const getUnitTrans = val => units[val] || val;

export default getUnitTrans;
